// Material UI
import { Typography } from "@mui/material";

export default function AdvisorPerformanceAnalyticsSectionLabel() {
	return (
		<Typography className="!font-montserrat !font-medium !text-2xl/[1.2] text-default !pt-8 pb-12" variant={"h3"}>
			Advisor Performance Analytics
		</Typography>
	);
}
